import { createReducer, on } from '@ngrx/store';
import { storeSecondFilePartnerRegister } from '../../actions/file-patner-register.actions';

export interface IStateSecondFilePartnerRegister {
  file: File | null;
}

export const initialState: IStateSecondFilePartnerRegister = {
  file : null
}

export const secondFilePartnerRegisterReducer = createReducer(
  initialState,
  on(storeSecondFilePartnerRegister, (state, { file }) => ({...state, file}))
)
